class BoxGiftCard extends HTMLElement {
    constructor() {
        super();

        this.blockId = this.getAttribute('block');

        this.modalOpener = this.querySelector('modal-opener button')
        this.modalDialog = document.querySelector(`#GiftCardModal-${this.blockId}`);
        this.views = this.modalDialog.querySelectorAll('.js-view');
        this.controls = this.modalDialog.querySelector('.js-controls');
        this.emailFields = this.modalDialog.querySelectorAll('.js-email');
        this.step = 1;

        this.deliveryRadios = this.modalDialog.querySelector('radio-delivery-selects');
        this.giftCardRadios = this.modalDialog.querySelector('radio-gift-card-selects');
        this.giftCardOptions = [];

        this.currentVariant = '';

        console.log('modalDialog', this.modalDialog)
        //console.log('DEL_RADIOS', this.deliveryRadios)
        //console.log('CARD_RADIOS', this.giftCardRadios)

        this.modalOpener.addEventListener('click', this.initModal.bind(this));

        this.controls.addEventListener('click', this.onStepChange.bind(this));

        this.deliveryRadios.addEventListener('change', this.onOptionChange.bind(this));
        this.giftCardRadios.addEventListener('change', this.onOptionChange.bind(this));

    }

    initModal() {
        console.log('initModal')
        this.step = 1;

        this.views.forEach((view) => view.classList.add('hidden'));
        this.modalDialog.querySelectorAll(`.js-view-${this.step}`).forEach(step => {
            step.classList.remove('hidden');
        })

        const prevControl = this.controls.querySelector("[data-control='prev']");
        const nextControl = this.controls.querySelector("[data-control='next']");
        const submitControl = this.controls.querySelector("[data-control='submit']");

        prevControl.classList.add('hidden');
        nextControl.classList.remove('hidden');
        submitControl.classList.add('hidden');


        if (this.deliveryRadios) {
            console.log(this.deliveryRadios.querySelector('input:checked').value)
            this.giftCardOptions[0] = this.deliveryRadios.querySelector('input:checked').value
        }

        if (this.giftCardRadios) {
            console.log(this.giftCardRadios.querySelector('input:checked').value)
            this.giftCardOptions[1] = this.giftCardRadios.querySelector('input:checked').value
        }
        console.log('OPTIONS_0', this.giftCardOptions)

        this.currentVariant = this.getVariantData().find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(this.giftCardOptions)
        });
        console.log(this.currentVariant)
        this.updateVariantInput();

    }

    onOptionChange(event) {
        console.log('OPTION', event.target.dataset.option)
        console.log('VALUE', event.target.value)

        this.giftCardOptions[event.target.dataset.option] = event.target.value

        console.log('GIFT OPTIONS', this.giftCardOptions)
        this.currentVariant = this.getVariantData().find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(this.giftCardOptions)
        });
        console.log('change', this.currentVariant)
        if (this.currentVariant.option2.includes('destinataire') || this.currentVariant.option2.includes('bénéficiaire')) {
            this.emailFields.forEach(field => {
                field.classList.remove('hidden');
            })
        } else {
            this.emailFields.forEach(field => {
                field.classList.add('hidden');
            })
        }
        this.modalDialog.querySelector('.js-price').innerText = (this.currentVariant.price / 100).toLocaleString('fr', { minimumFractionDigits: 2 });
        this.updateVariantInput();
    }


    onStepChange(event) {

        const prevControl = this.controls.querySelector("[data-control='prev']");
        const nextControl = this.controls.querySelector("[data-control='next']");
        const submitControl = this.controls.querySelector("[data-control='submit']");

        const expr = event.target.dataset.control;
        switch (expr) {
            case 'next':
                this.step = this.step + 1;
                this.views.forEach((view) => view.classList.add('hidden'));
                this.modalDialog.querySelectorAll(`.js-view-${this.step}`).forEach(step => {
                    step.classList.remove('hidden');
                })
                break;
            case 'prev':
                this.step = this.step - 1;
                this.views.forEach((view) => view.classList.add('hidden'));
                this.modalDialog.querySelectorAll(`.js-view-${this.step}`).forEach(step => {
                    step.classList.remove('hidden');
                })
                break;
            case 'submit':
                console.log('SUBMIT', this.giftCardOptions)
                this.currentVariant = this.getVariantData().find((variant) => {
                    return JSON.stringify(variant.options) === JSON.stringify(this.giftCardOptions)
                });
                console.log(this.currentVariant)
                break;
            default:
                console.log(`Sorry, we are out of ${expr}.`);
        }
        this.step > 1 ? prevControl.classList.remove('hidden') : prevControl.classList.add('hidden');
        if (this.step === 3) {
            prevControl.classList.remove('hidden');
            nextControl.classList.add('hidden');
            submitControl.classList.remove('hidden');
        } else {
            nextControl.classList.remove('hidden');
            submitControl.classList.add('hidden');
        }
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.blockId}, #product-form-installment-${this.blockId}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
        });
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector(`#giftCardOptions-${this.blockId}[type="application/json"]`).textContent);
        //console.log('getVariantData', this.variantData)
        return this.variantData;
    }
}
customElements.define('box-gift-card', BoxGiftCard);



if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');

                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';

                // mcp adds
                this.cartHasSellingPlan = false;
            }

            async onSubmitHandler(event) {
                event.preventDefault();
                console.log('onSubmitHandler', event.target)
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading__spinner').classList.remove('hidden');

                if (event.target.querySelector('input[name="selling_plan"]')) {
                    this.cartHasSellingPlan = await this.getCartItems();
                    console.log('cartHasSellingPlan RES', this.cartHasSellingPlan)
                    if (this.cartHasSellingPlan) {
                        let errorMessageWrapper = this.querySelector('.shipping-modal-form__error-message-wrapper');
                        if (errorMessageWrapper) {
                            errorMessageWrapper.toggleAttribute('hidden', false);
                        }
                        this.submitButton.classList.remove('loading');
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.querySelector('.loading__spinner').classList.add('hidden');
                    } else {
                        this.addItemToCart();
                    }
                } else {
                    this.addItemToCart();
                }
            }

            addItemToCart() {
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                console.log('CART', this.cart)
                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log('ADD TO CART', response)
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButton.querySelector('span').classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                cartData: response,
                            });
                        this.error = false;
                        // mcp adds
                        const modal = this.closest('quick-add-modal') || this.closest('modal-dialog');
                        if (modal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                },
                                { once: true }
                            );
                            modal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove('loading');
                        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                        this.querySelector('.loading__spinner').classList.add('hidden');
                    });
            }

            // mcp add
            async getCartItems() {
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                await fetch(`${routes.cart_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        console.log('RES', response.items)
                        if (response.item_count > 0) {
                            let sellingPlanItems = response.items.filter(item =>
                                item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.recurring_deliveries : false
                            )
                            sellingPlanItems.length > 0 ? this.cartHasSellingPlan = true : this.cartHasSellingPlan = false;
                            console.log('Check if cart as abo 2', this.cartHasSellingPlan)
                        } else {
                            this.cartHasSellingPlan = false;
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                return this.cartHasSellingPlan;
            }
            // end mcp adds

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}

